import React from 'react'
import { FormikProps } from 'formik'
import { Heading, Hr } from '@pandiafi/design-system'
import { ContextNotification } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { ModifyContractInput } from '../../../../../common/validations'
import {
  ModificationInEffectField,
  ModificationInEffectFieldProps,
} from '../../../ContractChanges/ModificationForm/ModificationInEffectField/ModificationInEffectField'
import { ModificationDescriptionField } from '../../../ContractChanges/ModificationForm/ModificationDescriptionField/ModificationDescriptionField'
import {
  TransferDestinationField,
  TransferDestinationFieldProps,
} from '../TransferDestinationField/TransferDestinationField'

type ContractPartyMoveOutDetailsProps = {
  form: FormikProps<ModifyContractInput>
  movingOutCount: number
  transferDestination: Omit<TransferDestinationFieldProps, 'form'> | undefined
  inEffectField: Omit<ModificationInEffectFieldProps, 'form'>
}

export const ContractPartyMoveOutDetails: React.FC<
  ContractPartyMoveOutDetailsProps
> = ({ form, movingOutCount, transferDestination, inEffectField }) => {
  const { t } = useTranslation(['contractModification'])

  const heading = transferDestination
    ? t('contractModification:headings.contractTransfer')
    : t('contractModification:headings.tenantLeaves', { count: movingOutCount })
  const info = transferDestination
    ? t('contractModification:texts.contractTransferInfo')
    : t('contractModification:texts.tenantLeavingDescription')

  return (
    <>
      <Hr className="my-10 border-common-gray-4" />

      <Heading size="l" element="h3" className="mb-4 font-medium">
        {heading}
      </Heading>

      {transferDestination && (
        <TransferDestinationField form={form} {...transferDestination} />
      )}

      <ModificationInEffectField form={form} {...inEffectField} />

      <ContextNotification type="info" textAlign="center" className="mt-8">
        {info}
      </ContextNotification>

      <ModificationDescriptionField form={form} />
    </>
  )
}
